export default {
  moduleTasks: [],
  moduleTask: undefined,
};
